export function canPlasterFinishCheckin({ next, store }) {
  if (
    typeof store.state.user.state !== "undefined" &&
    store.state.user.roles.includes("checkin-finitura-gesso")
  ) {
    return next();
  } else {
    return next("/login");
  }
}
